import { ChartFrequency, IComposableChartsWidget } from 'wisestep-api';

import CallsBarChartPostgres from '../../../../../features/composableAnalytics/BaseCharts/calls/postgres/CallsBarChartPostgres';
import CallsMetricChartPostgres from '../../../../../features/composableAnalytics/BaseCharts/calls/postgres/CallsMetricChartPostgres';
import CallsTablePostgres from '../../../../../features/composableAnalytics/BaseCharts/calls/postgres/CallsTablePostgres';
import { ChartScope } from '../../../types';
import { CallsWidget, getChartFreqForTimePeriod } from '../../helper';
import { jobsTimePeriodList } from '../../Jobs';

const callsWidgetsByTimeAndScope = (
  timePeriodId: string,
  scope: ChartScope,
  frequency: ChartFrequency = getChartFreqForTimePeriod[timePeriodId]
): Record<CallsWidget, IComposableChartsWidget> => {
  const defaultQuery = {
    category: 'calls',
    filters: [],
    type: 'total-metric',
    range: timePeriodId,
    scope,
    frequency,
  };

  const widgetConfig: Record<CallsWidget, IComposableChartsWidget> = {
    [CallsWidget.TOTAL_METRIC]: {
      name: 'Total Calls Made',
      filters: {},
      category: 'calls',
      type: `metric_calls_total_${timePeriodId}_${scope}_postgre`,
      component: (
        <CallsMetricChartPostgres
          query={{ ...defaultQuery, type: 'total-metric' }}
          title="Total Calls Made"
          widgetName={CallsWidget.TOTAL_METRIC}
        />
      ),
    },
    [CallsWidget.BAR_CHART]: {
      name: `Calls Made - ${frequency}`,
      filters: {},
      category: 'calls',
      type: `barchart_calls_${timePeriodId}_${scope}_${frequency}_postgre`,
      component: (
        <CallsBarChartPostgres
          query={{ ...defaultQuery, type: 'bar-chart' }}
          title={`Calls Made - ${frequency}`}
          widgetName={CallsWidget.BAR_CHART}
        />
      ),
    },
    [CallsWidget.RECRUITER_BY_TIME_TABLE]: {
      name: 'Calls By Recruiters By Time',
      filters: {},
      category: 'calls',
      type: `table_calls_recruiter_${timePeriodId}_${scope}_postgre`,
      component: (
        <CallsTablePostgres
          query={{ ...defaultQuery, type: 'recruiter-table' }}
          title="Calls By Recruiters By Time"
          widgetName={CallsWidget.RECRUITER_BY_TIME_TABLE}
        />
      ),
    },
    [CallsWidget.RECRUITER_DIRECTION_TABLE]: {
      name: 'Calls By Recruiters with Direction',
      filters: {},
      category: 'calls',
      type: `table_calls_recruiter_direction_${timePeriodId}_${scope}_postgre`,
      component: (
        <CallsTablePostgres
          query={{ ...defaultQuery, type: 'recruiter-direction-table' }}
          title="Calls By Recruiters with Direction"
          widgetName={CallsWidget.RECRUITER_DIRECTION_TABLE}
        />
      ),
    },
    [CallsWidget.RECRUITER_STATUS_TABLE]: {
      name: 'Calls By Recruiters with Status',
      filters: {},
      category: 'calls',
      type: `table_calls_recruiter_status_${timePeriodId}_${scope}_postgre`,
      component: (
        <CallsTablePostgres
          query={{ ...defaultQuery, type: 'recruiter-status-table' }}
          title="Calls By Recruiters with Status"
          widgetName={CallsWidget.RECRUITER_STATUS_TABLE}
        />
      ),
    },
    [CallsWidget.RECRUITER_TABLE]: {
      name: 'Calls By Direction with Recruiters',
      filters: {},
      category: 'calls',
      type: `table_calls_recruiter_without_time_direction_${timePeriodId}_${scope}_postgre`,
      component: (
        <CallsTablePostgres
          query={{ ...defaultQuery, type: 'direction-table' }}
          title="Calls By Direction with Recruiters"
          widgetName={CallsWidget.RECRUITER_TABLE}
        />
      ),
    },
    [CallsWidget.TEAM_TABLE]: {
      name: 'Calls By Team',
      filters: {},
      category: 'calls',
      type: `table_calls_recruiter_team_${timePeriodId}_${scope}_postgre`,
      component: (
        <CallsTablePostgres
          query={{ ...defaultQuery, type: 'team-table' }}
          title="Calls By Team"
          widgetName={CallsWidget.TEAM_TABLE}
        />
      ),
    },
  };
  return widgetConfig;
};

export const postgresCallsDashboardKeys = (
  timePeriodId: string,
  scope: ChartScope
): IComposableChartsWidget[] => {
  const defaultWidgetList = Object.values(callsWidgetsByTimeAndScope(timePeriodId, scope));
  const extraWidgetList = {};

  return [...defaultWidgetList, ...(extraWidgetList[timePeriodId] ?? [])];
};

export const postgreCallsDashboardKeysObjectList = jobsTimePeriodList.flatMap((timePeriod) => [
  ...postgresCallsDashboardKeys(timePeriod?.id, ChartScope.WORKSPACE),
  ...postgresCallsDashboardKeys(timePeriod?.id, ChartScope.LOGGED_IN_USER),
]);
